<template>
  <div id="app">
    <keep-alive>
      <!--会被缓存的视图组件-->
      <router-view v-if="$route.meta.keepAlive" class='router-view'></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
  export default {
    name: 'App',
    components: {

    },
    mounted() {
      console.log(this.$route)
      if (this.getUrlParamCN('lawboxId')) {
        localStorage.setItem('lawboxId', this.getUrlParamCN('lawboxId'))
      }
      if (localStorage.getItem('user')) {
        this.loginIM()
      }
    },
    methods: {
      getUrlParamCN(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
        var r = decodeURI(window.location.search).substr(1).match(reg); //匹配目标参数
        if (r != null) return unescape(r[2]);
        return null; //返回参数值
      }
    },
    watch: {
      '$route'() {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      }
    },
    destroyed() {
      localStorage.removeItem('showXl')
    }
  }
</script>

<style lang="scss">
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    max-width: 475px;
    min-width: 320px;
    margin: 0 auto;
  }

  * {
    padding: 0;
    margin: 0;
  }

  input:focus {
    outline: 0;
  }

  ::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #aaa;
  }

  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #aaa;
  }

  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #aaa;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #aaa;
  }

  /* 弹窗 */
  .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    opacity: .7;
    z-index: 99;
  }

  .modal_main {
    width: 270px;
    background: #FFFFFF;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    margin-top: -97.5px;
    left: 50%;
    margin-left: -135px;
    z-index: 999;
    box-sizing: border-box;
  }

  .modal_title {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #151515;
    text-align: center;
    margin-bottom: 15px;
    padding-top: 22px;
  }

  .modal_content {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 18px;
    padding: 0 35px;
    margin-bottom: 35px;
  }

  .modal_btn {
    border-top: 1px solid #E5E5E5;
    width: 100%;
    height: 45px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #0980FE;
    text-align: center;
    line-height: 44px;
  }

  .modal_tip {
    background: #FFF5EB;
    border-radius: 10px 10px 0px 0px;
    padding: 15px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FB7E01;
    line-height: 16px;
    margin-bottom: 40px;
  }

  .modal_content text {
    color: #0980FE;
    font-weight: bold;
  }

  .modal_btn2 {
    width: 100%;
    border-top: 1px solid #E5E5E5;
    height: 45px;
    position: relative;
  }

  .modal_btn2 button {
    width: 50%;
    display: inline-block;
    background: #fff;
    font-size: 16px;
    color: #333333;
    border-radius: 0 0 0 10px;
    height: 45px;
    line-height: 44px;
    padding: 0;
    border: 0;
  }

  .modal_btn2 button:nth-child(1) {
    border-right: 1px solid #E5E5E5;
  }

  .modal_btn2 button:nth-child(2) {
    border-radius: 0 0 10px 0;
    color: #0980FE;
  }

  .popup_img_busy {
    width: 100%;
    // height: 228rpx;
    position: absolute;
    top: -96px;
    left: 50%;
    margin-left: -50%;
  }

  .modal_main_busy .modal_title {
    padding-top: 54px;
  }

  .modal_main_busy .modal_content {
    padding: 0 50px;
  }

  .modal_main_busy .modal_btn2 img {
    width: 45px;
    height: 15px;
    position: absolute;
    top: -4.5px;
    right: 18px;
  }
</style>